module.exports = __webpack_public_path__ + "img/p6.1154e858.png";